import {
    backgroundColorNormal,
    backgroundColorSuccess,
    backgroundColorWhite,
    borderColorDisabled,
    borderColorLight,
    ColorBlueDark,
    ColorGrey6,
    textColorOpacity,
} from './palette';

export const labelEditorButtonBg = backgroundColorNormal;
export const labelEditorButtonBgHover = ColorBlueDark;

export const labelEditorModuleBg = backgroundColorWhite;

export const labelEditorItemBg = ColorGrey6;
export const labelEditorItemBorder = borderColorDisabled;

export const labelEditorCreateBg = backgroundColorWhite;
export const labelEditorCreateBgActive = backgroundColorSuccess;
export const labelEditorCreateBorder = borderColorLight;
export const labelEditorCreateShadow = textColorOpacity;
